import { Z_STACK } from '../config/layout'
import { useExperienceStore } from '../store/experienceStore'

export function PrivacyBanner({ onAccept }: { onAccept: () => void }) {
  const privacyAccepted = useExperienceStore((s) => s.privacyAccepted)

  if (privacyAccepted) return null

  return (
    <div
      className="modal-backdrop"
      style={{ zIndex: Z_STACK.modal }}
      role="dialog"
      aria-labelledby="privacy-title"
    >
      <div className="modal-card privacy-card">
        <p className="modal-kicker">Lucy · Time Gesture</p>
        <h1 id="privacy-title">用真实手势，掌控时间</h1>
        <p className="modal-body">
          本体验会请求摄像头权限，用于将你的影像合成到场景中，并在浏览器本地进行手势识别。
          <strong>影像数据仅在本机处理，不会上传到任何服务器。</strong>
        </p>
        <ul className="privacy-list">
          <li>摄像头画面本地实时处理</li>
          <li>可随时拒绝，改用鼠标 / 键盘控制时间</li>
          <li>离开页面时自动关闭摄像头</li>
        </ul>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-primary"
            onClick={() => {
              useExperienceStore.getState().setPrivacyAccepted(true)
              onAccept()
            }}
          >
            开启体验（授权摄像头）
          </button>
          <button
            type="button"
            className="btn-ghost"
            onClick={() => {
              useExperienceStore.getState().setPrivacyAccepted(true)
              useExperienceStore.getState().setCameraGranted(false)
              useExperienceStore.getState().setInputMode('mouse')
              useExperienceStore.getState().setOnboardingStep(0)
              // skip camera
              onAccept()
            }}
          >
            仅用键鼠体验
          </button>
        </div>
      </div>
    </div>
  )
}
